'use strict';

Object.defineProperty(exports, '__esModule', {
    value: true
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _normalizeStyles = require('./normalize-styles');

var _normalizeStyles2 = _interopRequireDefault(_normalizeStyles);

/**
 * @typedef {Object} StyledChunk
 * @property {string} text - The text `styles` applies to
 * @property {string[]} styles - The styles to apply to `text`
 */

/**
 * Finds all line breaks in the text and returns styles for them
 * @param {string} text The text to find line breaks in
 * @return {ArticleFormatStyle[]} An array of styles for the line breaks
 */
function findLineBreakStyles(text) {
    var lineBreakIndices = [];
    var lineBreakIndex = -1;
    do {
        lineBreakIndex = text.indexOf('\n', lineBreakIndex + 1);
        if (lineBreakIndex !== -1) {
            lineBreakIndices.push(lineBreakIndex);
        }
    } while (lineBreakIndex !== -1);

    return lineBreakIndices.map(function (index) {
        return { type: 'br', length: 1, offset: index };
    });
}

/**
 * Turns `text` into chunks where each chunk has the corresponding styles from `styles` listed
 *
 * @param {string} text The text to chunkify
 * @param {ArticleFormatStyle} styles The styles to chunkify
 * @return {StyledChunk[]} `text` turned into an array of {@link StyledChunk}
 */
function chunkify(text) {
    var styles = arguments.length <= 1 || arguments[1] === undefined ? [] : arguments[1];

    var completeStyles = styles.concat(findLineBreakStyles(text));
    if (!completeStyles.length) {
        return [{
            text: text,
            styles: []
        }];
    }

    var normalizedStyles = (0, _normalizeStyles2['default'])(completeStyles, text.length);

    return normalizedStyles.map(function (_ref) {
        var offset = _ref.offset;
        var length = _ref.length;
        var chunkStyles = _ref.styles;
        return {
            text: text.substr(offset, length),
            styles: chunkStyles
        };
    });
}

exports['default'] = chunkify;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./~/@aftonbladet/stylizr/lib/chunkify.js
 ** module id = 452
 ** module chunks = 1
 **/